export default __webpack_public_path__ + "static/media/5.5.1c11d466.jpg";